import PrimaryHeader from '../Headers/PrimaryHeader/PrimaryHeader'

const PrimaryLayout = ({ children }) => {
  return (
    <>
      <PrimaryHeader />
      <div className='md:max-w-7xl md:mx-auto  min-h-[calc(100%_-_128px)] '>
        {children}
      </div>
    </>
  )
}

export default PrimaryLayout
